import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useQueryParams } from 'hooks/UseQueryParams';

import type { UseGalleryOnPageArgs } from 'components/Toolkit/Gallery/GalleryOnPage.hook.typed';
import type { GalleryUsageData } from 'components/Toolkit/Gallery/types/galleryTypes';

const useGalleryOnPage = (props: UseGalleryOnPageArgs) => {
  const { reportOnGalleryUsage, setIsGalleryOpen, displayImage } = props;

  const MODAL_QUERY_KEY = 'modal';
  const MODAL_QUERY_VALUE = 'gallery';

  const { addQueries: openModal, checkIfQueryIsPresent: checkIfModalIsOpen } =
    useQueryParams();

  const { query, back } = useRouter();

  useEffect(() => {
    // On load of this component we preload the first image in
    // the lightbox so when the user opens it they get an instant load
    const firstImageOfLightboxToPreload = new Image();
    // One of two optional parameters will always be available to set as src
    firstImageOfLightboxToPreload.src = displayImage!;
  }, []);

  const openGallery = () => {
    openModal({ modal: MODAL_QUERY_VALUE });
    reportOnGalleryUsage && reportOnGalleryUsage({ event: 'OPEN' });
  };

  const closeGallery = (usageData: GalleryUsageData) => {
    back();
    {
      reportOnGalleryUsage &&
        reportOnGalleryUsage({ event: 'CLOSE', data: usageData });
    }
  };

  useEffect(() => {
    if (checkIfModalIsOpen(MODAL_QUERY_KEY, MODAL_QUERY_VALUE)) {
      setIsGalleryOpen(true);
    } else {
      setIsGalleryOpen(false);
    }
  }, [query]);

  return {
    openGallery,
    closeGallery,
  };
};

export { useGalleryOnPage };
